import { useHttpClient } from '@/common/api/httpClient';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from 'shared/translations/stores/languageStore';

export interface ChangeProductionOrderRequest {
  storageAreaId: string;
  productionOrderId: string | null;
}

export function useChangeProductionOrderApi() {
  return {
    execute,
  };

  async function execute(data: ChangeProductionOrderRequest) {
    const httpClient = useHttpClient();
    const languageStore = useLanguageStore();
    const { translations } = storeToRefs(languageStore);

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl('productionorder/change'), {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    });

    const text = translations.value.productionOrders.actions.change;

    const response = await httpClient.action(request, {
      title: text.title,
      errorTitle: text.error,
      processOk: async () => {
        return {
          ok: true,
        };
      },
    });

    return response;
  }
}
